module.exports = __webpack_public_path__ + "img/imgZXGH(34).d825fa28.png";